export const TOOL_TASK = 'remove-attendees';
export const TOOL_TITLE = 'Remove Attendees';
export const TOOL_PROGRESS_LABEL = 'Bulk removing attendees progress...';
export const TOOL_STACK_OVERFLOW_MESSAGE = 'Please try again once removing attendees finishes';
export const FILE_NAME = 'Remove-attendees-report';
export const FILE_HEADERS = {
    userId: 'User ID',
    email: 'User Email',
    conferenceAccountId: 'Conference Account ID',
    conferenceName: 'Conference Name',
    actionStatus: 'Action Status',
};
